var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "file-uploader-container" }, [
    !_setup.uploadedFile
      ? _c(
          "div",
          {
            staticClass: "upload-area",
            class: { "drag-over": _setup.isDragOver },
            on: {
              dragover: function ($event) {
                $event.preventDefault()
                return _setup.onDragOver.apply(null, arguments)
              },
              dragleave: function ($event) {
                $event.preventDefault()
                return _setup.onDragLeave.apply(null, arguments)
              },
              drop: function ($event) {
                $event.preventDefault()
                return _setup.onDrop.apply(null, arguments)
              },
              click: _setup.triggerFileInput,
            },
          },
          [
            _c("input", {
              ref: "fileInput",
              staticStyle: { display: "none" },
              attrs: { type: "file", accept: _vm.accept },
              on: { change: _setup.onFileSelect },
            }),
            _c("div", { staticClass: "upload-content" }, [
              _c("div", { staticClass: "upload-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "32",
                      height: "32",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" },
                    }),
                    _c("polyline", { attrs: { points: "17,8 12,3 7,8" } }),
                    _c("line", {
                      attrs: { x1: "12", y1: "3", x2: "12", y2: "15" },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "upload-text" }, [
                _vm._v(" " + _vm._s(_vm.dragDropText) + " "),
              ]),
              _c("div", { staticClass: "file-types" }, [
                _vm._v(" " + _vm._s(_vm.fileTypesText) + " "),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _setup.uploadedFile
      ? _c(
          "div",
          {
            staticClass: "file-item",
            class: { "has-error": _setup.hasErrorMessage },
          },
          [
            _c("div", { staticClass: "file-icon" }, [
              _setup.hasErrorMessage
                ? _c(
                    "svg",
                    {
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "3",
                          y: "2",
                          width: "18",
                          height: "20",
                          rx: "2",
                          fill: "#ef4444",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M7 6h10M7 10h10M7 14h7",
                          stroke: "white",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  )
                : _c("img", {
                    attrs: {
                      src: require("@/assets/images/svg/icon-microsoft-excel.svg"),
                      width: "24",
                      height: "24",
                      alt: "Excel file icon",
                    },
                  }),
            ]),
            _c("div", { staticClass: "file-info" }, [
              _c("div", { staticClass: "file-name" }, [
                _vm._v(_vm._s(_setup.uploadedFile.name)),
              ]),
              _c("div", { staticClass: "file-details" }, [
                _c("span", { staticClass: "file-size" }, [
                  _vm._v(_vm._s(_setup.formatBytes(_setup.uploadedFile.size))),
                ]),
                _setup.hasErrorMessage
                  ? _c("span", { staticClass: "error-status" }, [
                      _vm._v(_vm._s(_vm.errorStatusText)),
                    ])
                  : _setup.uploadProgress < 100
                  ? _c("span", { staticClass: "upload-status" }, [
                      _vm._v(_vm._s(_vm.uploadStatusText)),
                    ])
                  : _vm._e(),
              ]),
              !_setup.hasErrorMessage && _setup.uploadProgress < 100
                ? _c("div", { staticClass: "progress-bar" }, [
                    _c("div", {
                      staticClass: "progress-fill",
                      style: { width: _setup.uploadProgress + "%" },
                    }),
                  ])
                : _vm._e(),
            ]),
            !_setup.hasErrorMessage && _setup.uploadProgress < 100
              ? _c("div", { staticClass: "upload-percentage" }, [
                  _vm._v(
                    " " + _vm._s(Math.round(_setup.uploadProgress)) + "% "
                  ),
                ])
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "remove-file-btn",
                on: { click: _setup.removeUploaderFile },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                    },
                  },
                  [
                    _c("line", {
                      attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                    }),
                    _c("line", {
                      attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                    }),
                  ]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
    _setup.uploadedFile && _setup.hasErrorMessage
      ? _c("div", { staticClass: "error-message" }, [
          _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }